/** #################################### Generated content ####################################
 * This block has been generated with deppy create-index (for more information https://github.com/webedx-spark/deppy)
 * */

export { default as ThreadDetailsStore } from 'bundles/discussions/stores/ThreadDetailsStore';
export { default as ThreadSettingsStore } from 'bundles/discussions/stores/ThreadSettingsStore';
/**
 * @description generated: list of files importing the export below
 * bundles/ondemand/appEnv
 * bundles/teach-course/appEnv
 * */
export { default as SessionFilterStore } from 'bundles/discussions/stores/SessionFilterStore';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/v1/LandingPageThreadsViewWrapper
 * */
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
export { default as DiscussionsBody } from 'bundles/discussions/components/discussionsBody/DiscussionsBody';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsLandingPageTabs
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsMainColumn
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsLandingPageTabs
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsLandingPageTabs
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsMainColumn
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsWeekForums
 * */
export {
  getEmbeddedItemDiscussionsUrl,
  getCourseRootPath,
  buildUrl,
  getAllThreadsDiscussionsUrl,
  getWeekDiscussionsUrl,
  getCourseDiscussionsUrl,
  getCourseDiscussionsTabUrl,
} from 'bundles/discussions/utils/discussionsUrl';
export { legacyHydrate } from 'bundles/discussions/utils/hydrate';
/**
 * @description generated: list of files importing the export below
 * bundles/graded-discussion-prompt/components/GdpReplyContainer
 * bundles/naptimejs/resources/onDemandCourseForums.v1
 * bundles/naptimejs/resources/onDemandMentorForums.v1
 * bundles/authoring/discussions/components/DiscussionsAuthoringApp
 * bundles/authoring/discussions/components/DiscussionsAuthoringEditor
 * bundles/authoring/discussions/components/DiscussionsForumRow
 * bundles/authoring/discussions/components/DiscussionsSubforumRow
 * bundles/authoring/discussions/components/ForumDeleteButton
 * bundles/authoring/discussions/stores/AuthorDiscussionsDraftStoreV2
 * bundles/authoring/discussions/stores/AuthorDiscussionsStoreV2
 * bundles/authoring/discussions/utils/AuthorDiscussionsApiUtils
 * bundles/authoring/discussions/utils/CourseForumsApi
 * bundles/authoring/discussions/utils/ForumVisibilityFactory
 * bundles/authoring/discussions/utils/MentorForumsApi
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsDescription
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/cds/LandingPageSearchResultsSummary
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/personalization/LandingPageSearchResultsSummary
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsDescription
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/v1/LandingPageSearchResultsSummary
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsDescription/index
 * */
export {
  savingStates,
  naptimeForumTypes,
  loadingStates,
  forumLimit,
  forumVisibilityTypes,
  defaults,
  gradedDiscussionPromptTypes,
  answers,
} from 'bundles/discussions/constants';
export type { LoadingState, SavingState } from 'bundles/discussions/constants';
export { default as ReplyCMLInput } from 'bundles/discussions/components/repliesList/ReplyCMLInput';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsDescription
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsGroupForums
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/cds/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsGroupForums
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/personalization/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsCourseForums
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsDescription
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsGroupForums
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsWeekForums
 * bundles/course-home/page-discussion-forums/components/v1/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsDescription/index
 * */
export { default as discussionsForumsHOC } from 'bundles/discussions/components/discussionsForumsHOC';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsWeekForums
 * */
export type { Forum } from 'bundles/discussions/lib/types';
export { fetchAnswers, fetchMultipleCommentPages } from 'bundles/discussions/actions/ThreadDetailsActions';
// FIXME: existing import/no-cycle violations are excused to prevent seeing errors when modifying other parts of the same file; please fix it carefully
// eslint-disable-next-line import/no-cycle
export { default as RepliesList } from 'bundles/discussions/components/repliesList/RepliesList';
/**
 * @description generated: list of files importing the export below
 * bundles/item/components/DiscussionPromptWrapper
 * */
export { default as DiscussionPromptContainer } from 'bundles/discussions/components/discussionPrompt/DiscussionPromptContainer';
export { default as sessionsApi } from 'bundles/discussions/api/sessions';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsLandingPageHeader
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsLandingPageHeader
 * */
export { default as SessionFilter } from 'bundles/discussions/components/sessionFilter/SessionFilter';
/**
 * @description generated: list of files importing the export below
 * bundles/profile/promises/getAnswersByCourseForumId
 * */
export { loadReplies } from 'bundles/discussions/api/repliesApi';
/**
 * @description generated: list of files importing the export below
 * bundles/profile/promises/getAnswersByCourseForumId
 * bundles/profile/promises/getQuestionsByCourseForumId
 * */
export { getQuestionsById, load } from 'bundles/discussions/api/threadsApi';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/v1/DiscussionsLandingPage
 * */
export { default as withMaybeAddHelpersMutation } from 'bundles/discussions/hoc/withMaybeAddHelpersMutation';
export { default as ThreadPreviewList } from 'bundles/discussions/components/ThreadPreviewList';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/CourseHomeDiscussionsPage
 * bundles/course-home/page-discussion-forums/components/personalization/CourseHomeDiscussionsPage
 * bundles/course-home/page-discussion-forums/components/v1/CourseHomeDiscussionsPage
 * */
export { default as app } from 'bundles/discussions/app';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsLandingPage
 * */
export { default as DiscussionsCurrentWeekLoaderV2 } from 'bundles/discussions/components/forumsV2-DiscussionsCurrentWeekLoader';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/personalization/LandingPageThreadsViewWrapper
 * */
export { default as DiscussionsBodyV2 } from 'bundles/discussions/components/forumsV2-discussionsBody/DiscussionsBodySearch';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/personalization/LandingPageThreadsViewWrapper
 * bundles/course-home/page-discussion-forums/components/v1/LandingPageThreadsViewWrapper
 * */
export { default as routerConnectToCurrentForum } from 'bundles/discussions/utils/routerConnectToCurrentForum';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsLandingPage
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsSideColumn/index
 * */
export { default as DiscussionsCurrentWeekLoaderPersonalization } from 'bundles/discussions/components/personalization-DiscussionsCurrentWeekLoader';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/cds/DiscussionsModerators
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsModerators
 * */
export { default as ProfileArea } from 'bundles/discussions/components/profiles/ProfileArea';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsSideColumn/index
 * */
export { default as SessionFilterPersonalization } from 'bundles/discussions/components/personalization-sessionFilter';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsMainColumn
 * */
export { default as SearchBox } from 'bundles/discussions/components/personalization-Search/SearchBox';
export { default as NewThreadButton } from 'bundles/discussions/components/personalization-NewThreadButton';
export { default as PostsForYouTabBody } from 'bundles/discussions/components/personalization/__components/PostsForYouTabBody';
export { default as YourActivityTabBody } from 'bundles/discussions/components/personalization/__components/YourActivityTabBody';
/**
 * @description generated: list of files importing the export below
 * bundles/course-home/page-discussion-forums/components/personalization/DiscussionsSearchPage
 * */
export { default as DiscussionsBodyPersonalization } from 'bundles/discussions/components/personalization-discussionsBody/DiscussionsBody';

/**
 *  #################################### Generated content ####################################
 * */
